// extracted by mini-css-extract-plugin
export default {"course":"Course_course__LvO7v","container":"Course_container__Ll0MI","text":"Course_text__jAniI","rss":"Course_rss__aViVL"};